import { render, staticRenderFns } from "./VideoCheckoutBuy.vue?vue&type=template&id=171506f4&scoped=true&"
import script from "./VideoCheckoutBuy.vue?vue&type=script&lang=js&"
export * from "./VideoCheckoutBuy.vue?vue&type=script&lang=js&"
import style0 from "./VideoCheckoutBuy.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideoCheckoutBuy.vue?vue&type=style&index=1&id=171506f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171506f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCarousel,VCarouselItem,VCol,VItem,VItemGroup,VRow})
